import { useState } from 'react';
import './Blog.scss';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Popup from '../../components/Popup';
import Image from './4.jpg';

const BlogPage = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />
      <div className='blogPageMainScreen'>
        <div className='blogPageMainScreenContent'>
          <span className='blogPageMainScreenBack' onClick={() => navigate('/blog')}>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
              <path
                d='M7.9987 12.6667L3.33203 7.99999M3.33203 7.99999L7.9987 3.33333M3.33203 7.99999H12.6654'
                stroke='#3A6376'
                stroke-width='1.33'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Back to Articles
          </span>
          <h1 className='blogPageMainScreenTitle'>Navigating Major Staffing Shortages in Healthcare</h1>
          <span className='blogPageMainScreenDate'>November 20, 2025</span>
          <div className='blogPageMainScreenImage'>
            <img src={Image} />
          </div>
        </div>
      </div>
      <div className='blogPageContent'>
        <h3>CRISIS OVERVIEW</h3>
        <p>
          Unprecedented shortages of qualified healthcare staff pose immediate and long-term concerns for health care
          organizations, affecting patient outcomes and the overall strength of the business.
        </p>
        <p>
          An important topic in the healthcare industry, today’s leaders are feeling pressure to fill openings for the vast number
          of the new job needed, resignations, a growing retirement population, and a host of other reasons contributing to the
          abundance of job vacancies. The U.S. Bureau of Labor Statistics’s (BLS) 2016–2026 employment survey projects an alarming
          1.26 million total health care job openings per year, estimating that there will be 624,000 vacancies per year for all
          practitioners and technical occupations, including the need for 204,000 registered nurses (RNs).
        </p>
        <h3>STATISTICS ON SHORTAGE PROJECTIONS</h3>
        <ul>
          <li>
            The American Association of Medical Colleges estimates a possible shortage of more than 100,000 physicians by 2030
            (Mann 2017).
          </li>
          <li>
            Various research reports forecast significant nursing shortages, including a deficit of more than 150,000 RNs by 2020
            and more than 500,000 by 2030 (Zhang et al. 2018). Another report predicts a shortfall of 193,000 nurses by 2020
            (Carnevale, Smith and Gulish 2015).
          </li>
          <li>
            Because of budget constraints and a lack of faculty, clinical sites, classroom space and clinical preceptors, U.S.
            nursing schools turned away 64,067 qualified applicants in 2016 and 2017 (Fang et al. 2017).
          </li>
          <li>
            Supply-and-demand models predict a shortage of 26,560 physical therapists by 2025 (American Physical Therapy
            Association 2017).
          </li>
          <li>
            By 2025, the nation will likely face a shortage of 29,400 nurse practitioners and 98,700 medical and lab technologists
            and technicians (Stevenson 2018).
          </li>
        </ul>
        In AHA Data & Insights’ Futurescan Report, CHRO Denise J. Mariotti from the Hospital of the University of Pennsylvania
        shares,
        <div className='blogPageContentQuote'>
          “Solving workforce shortages is a top priority for executives in the rapidly changing health care environment. In fact,
          the vast majority of those responding to the latest Futurescan survey indicates it is or is very likely to be one of
          their three most significant challenges over the next five years.”
        </div>
        <p>
          Today’s staffing shortage demands that leaders maximize existing approaches within their organizations that return
          predictable success and adopt new ways of retaining and acquiring top talent.
        </p>
        <h2>MITIGATION STRATEGIES</h2>
        <h4>INCREASED INTERNAL EXPENDITURES</h4>
        <p>
          Healthcare executives report that many of their organization are allocating funds for higher salaries, staff engagement,
          and recruitment. In addition, many are investing in comprehensive studies to ensure they are offering competitive
          compensation beyond salaries for in-demand positions at all levels of the organization (not just management).
        </p>
        <h4>FOCUS ON QUALITY OF EMPLOYMENT</h4>
        <p>
          Investing in new-employee onboarding processes and rethinking work processes to increase efficiency and employee
          satisfaction are top retention strategies. Employers are also developing sophisticated programs to help staff members to
          find “joy in practice” and combat burnout and disengagement.
        </p>
        <h4>TARGET GEN X, Y, AND Z IN THEIR ONLINE ENVIRONMENTS</h4>
        <p>
          The next generation of healthcare professionals are digital natives, so recruiting efforts should leverage all of the
          media they use most from social media to digital job boards. Leveraging staffing firms and partners with a pulse on the
          digital behaviors of tech-savvy candidates can increase efficiency and volume while preserving the necessary elements of
          employer-employee matching.
        </p>
        <h4>LEVERAGING DIGITAL SOLUTIONS</h4>
        <p>
          Using new data/technology tools such as marketing automation, predictive analytics, search engines, and mobile platforms
          increase the likelihood that your message will be heard. Establish a national recruitment strategy by procuring advanced
          data analytics expertise for workforce sourcing from trusted partners.
        </p>
        <h4>INTERNAL EDUCATION & PROFESSIONAL DEVELOPMENT</h4>
        <p>
          To compete on the national level and attract top talent, commit resources toward sponsored professional development
          opportunities as well as fellowships, mentoring programs, paid internships, job shadowing, tuition
          assistance/reimbursement, and loan forgiveness as part of the non-salary benefits. Also, consider reinventing the
          organization’s clinical education and training programs to offer a unique (and attractive) solution like no other.
        </p>
        <h4>EXPAND THE REACH</h4>
        <p>
          Partner with regional colleges and universities to build educational programs that can serve as hiring pipelines,
          leveraging the institution’s marketing team to educate younger students about potential careers in healthcare. On the
          other side of the age spectrum, establish programs for veterans and retirees to begin or continue employment.
        </p>
        <p>
          There is no magic solution for health care organizations to solve the challenges of workforce shortages; however, there
          are positive indicators of success on the horizon. Healthcare systems demonstrating an aggressive enthusiasm for change,
          creative problem solving, and those that champion empowerment at every level of the organization with a focus on
          managing to a new generation of employees are having a positive impact on addressing the shortages.
        </p>
        <div className='blogPageContentQuote'>Voluntary terminations accounted for 92.7% of all hospital separations.</div>
        <br />
        <br />
        <i>
          Sources American Physical Therapy Association. 2017. “A Model to Project the Supply and Demand of Physical Therapists:
          2010–2025.” Updated April 17. www.apta.org/WorkforceData/ModelDescriptionFigures/.
          <br />
          <br />
          Carnevale, A., N. Smith and A. Gulish. 2015. “Nursing Supply and Demand Through 2020.” Georgetown University Center on
          Education and the Workforce. Accessed July 24, 2018. https://cew.georgetown.edu/ cew-reports/nursingprojections/.
          <br />
          <br />
          Fang, D., Y. Li, K.A. Kennedy and D.E. Trautman. 2017. 2016–2017 Enrollment and Graduations in Baccalaureate and
          Graduate Programs in Nursing. Washington, DC: American Association of Colleges of Nursing.
          <br />
          <br />
          2. Future Scan: Healthcare Trends and Implications, 2019-2024. AHA Data & Insights. January 2019.
          <br />
          <br />
          Mann, S. 2017. “Research Shows Shortage of More Than 100,000 Doctors by 2030.” AAMC News. Published March 14.
          https://news.aamc.org/medical-education/article/new-aamc-research-reaffirms-looming-physicianshor/.
          <br />
          <br />
          Stevenson, M. 2018. Demand for Healthcare Workers Will Outpace Supply by 2025: An Analysis of the US Healthcare Labor
          Market. Mercer LLC. Accessed November 15. www.mercer.com/content/dam/mercer/attachments/
          private/gl-career-2018-demand-for-healthcare-workers-will-outpace-supply-by-2025-analyisis-healthcarelabor-market-mercer.pdf.
          <br />
          <br />
          Zhang, X., D. Tai, H. Pforsich and V.W. Lin. 2018. “United States Registered Nurse Workforce Report Card and Shortage
          Forecast: A Revisit.” American Journal of Medical Quality 33 (3): 229–36.
        </i>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <Footer />
    </div>
  );
};

export default BlogPage;
